export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_nerotecnologia.png",
      alt: "Nome da extensão",
    },
    title: "SniperAI Elite",
    text: [
      "Desenvolvido com tecnologia de análise multi-timeframe, o Sniper AI Elite identifica padrões estratégicos do mercado em diferentes tempos gráficos simultaneamente, cruzando informações de curto, médio e longo prazo até encontrar o momento ideal para execução. ",
    ],
    testimonial: {
      text: "R$ 147,00 ate 5 ctt ",
      author: {
        name: "Nero Tecnologia Informatica Ltda",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  features: {
    title: "Por que utilizar os robôs da Nero Tecnologia?",
    subtitle: "Veja quais as principais vantagens dos robôs da Nero Tecnologia.",
    data: [
      {
        title: "Velocidade",
        description:
          "Nossos algoritmos realizam milhares de cálculos por segundo e tomam decisões muito mais rápido do que qualquer ser humano.",
      },
      {
        title: "Ganhe tempo",
        description:
          "Escolha suas estratégias e deixe que a plataforma opere por você. Não é necessário acompanhar o mercado o tempo todo.",
      },
      {
        title: "Sem emocional",
        description: "Com estratégias automatizadas, você elimina decisões impulsivas e irracionais nos investimentos.",
      },
    ],
  },
  cta: {
    title: "Pode seguir o mesmo padrao, só o nome SniperIA ",
    subtitle: "Ative agora mesmo a Nero Tecnologia",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Nero Tecnologia",
    col1: [
      "A Nero Tecnologia é uma empresa especializada no desenvolvimento de soluções de software para grandes empresas dos setores bancário e de investimentos.",
      "Com sólida experiência em tecnologia e arquitetura de sistemas de alta performance, a Nero Tecnologia expandiu sua atuação para o mercado financeiro, onde passou mais de 6 anos aperfeiçoando estratégias de Day Trade e Swing Trade através de estudos, análise de mercado e inteligência artificial. ",
    ],
    col2: [
      "Unindo tecnologia avançada, análise quantitativa e gestão operacional controlada, a empresa desenvolveu algoritmos inteligentes capazes de interpretar o comportamento do mercado em tempo real, identificando padrões, tendências e oportunidades operacionais com precisão.",
      "O resultado é uma tecnologia proprietária construída para atuar de forma estratégica, adaptativa e consistente, consolidando resultados positivos ao longo de meses de operação através de uma gestão focada em controle de risco, estabilidade e performance. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Nero Tecnologia",
  },
  strategies: {
    title: "INTELIGÊNCIA ARTIFICIAL OPERANDO O MERCADO POR VOCÊ",
    heading: "Tenha acesso às melhores estratégias de day trade",
    subtitle: "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },
  testimonials: [
    {
      text: "Operar com este bot foi uma das melhores escolhas que fiz, sem médio, controle e risco definidos, costumo brincar que é “play and forget”. Me deu muita tranquilidade no dia a dia, ter acesso a uma ferramenta robusta como essa. ",
      author: "Uender",
      job: "advogado, investidor profissional.",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
  ],
};
